<ng-template
  (backdropClick)="closeProfileMenu()"
  [cdkConnectedOverlayBackdropClass]="'profile-menu-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isExpanded"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay
>
  <div
    *ngIf="isExpanded"
    class="expandable-container bg-white w-full bg-opacity-100"
  >
    <a
      (click)="eachProfileMenuOptionClick(eachOption)"
      *ngFor="let eachOption of config"
      class="section flex flex-row
          justify-start items-center
          text-cool-grey font-work-sans
          font-normal  cursor-pointer"
    >
      {{ eachOption.name }}
    </a>
  </div>
</ng-template>

<div #trigger="cdkOverlayOrigin"
     (click)="openProfileMenu()"
     cdkOverlayOrigin
     class="profile-menu flex flex-row
            justify-start items-center
            space-x-[1rem]
            cursor-pointer
            border-t-[#C2C1D5]
            border-t-[0.1rem] bg-opacity-100
            xs:justify-start xs:pl-[1rem]"
>
  <div class="profile-image rounded-full
              border  flex flex-row
              justify-center items-center
              text-cool-grey font-poppins
              font-bold {{!profile?.avatar?.url ? 'p-[2rem]':'p-0'}}"
  >
    <app-image
      *ngIf="profile?.avatar?.url;else tempAvatar"
      [url]="profile?.avatar?.url"
    ></app-image>
    <ng-template #tempAvatar>
      <div>
        {{ profileAvatar | uppercase }}
      </div>
    </ng-template>
  </div>
  <span class="name">{{ profile?.firstName | titlecase }} {{ profile?.lastName | titlecase }}</span>
  <div class="mt-[1rem]">
    <app-icon
      class="icon"
      svgIcon="{{isExpanded?'arrow-down':'arrow-up'}}"
    ></app-icon>
  </div>
</div>
